import { useQuery } from '@tanstack/react-query';
import { SectorComercial, UnidadNegocio } from '../../../../../types';
import { HttpCacheOperacion } from '../../../api/httpCacheOperacion';
import { EntidadCache } from 'src/pages/sistema/types/types';


export const useADLUnidadNegocio = (codPais: number | undefined | null, codSistema: number | undefined | null) => {
  const {
    data: unidadNegocio = [],
    isLoading,
    isError,
    error
  } = useQuery<UnidadNegocio[], Error>({
    queryKey: ['ADL-unidad-negocio', codPais, codSistema],
    queryFn: () => HttpCacheOperacion.getUnidadesNegocioPorPaisYSistema(codPais!, codSistema!),
    enabled: !!codPais && !!codSistema
  })

  return {
    unidadNegocio,
    isLoading,
    isError,
    error
  }
}


export const useADLSectorComercialTipos = (codUnidadNegocio: number | undefined | null, codSistema: number | undefined | null) => {
  const {
    data: sectorComercialTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<SectorComercial[], Error>({
    queryKey: ['ADL-sector-comercial-tipos', codUnidadNegocio, codSistema],
    queryFn: () => HttpCacheOperacion.getSectoresComercialesPorUnidadNegocio(codUnidadNegocio!, codSistema!),
    enabled: !!codUnidadNegocio && !!codSistema
  })

  return {
    sectorComercialTipos,
    isLoading,
    isError,
    error
  }
}

export const useADLClienteTipos = (codPais: number | undefined | null) => {
  const {
    data: clienteTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<EntidadCache[], Error>({
    queryKey: ['ADL-clinete-tipos', codPais],
    queryFn: () => HttpCacheOperacion.getADLClienteTipos(codPais!),
    enabled: !!codPais
  })

  return {
    clienteTipos,
    isLoading,
    isError,
    error
  }
}

export const useADLLegislacionTipos = (codPais: number | undefined | null) => {
  const {
    data: legislacionTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<EntidadCache[], Error>({
    queryKey: ['ADL-emisor-tipos', codPais],
    queryFn: () => HttpCacheOperacion.getADLLegislacionTipos(codPais!),
    enabled: !!codPais
  })

  return {
    legislacionTipos,
    isLoading,
    isError,
    error
  }
}
